// Auto-generated build metadata - DO NOT EDIT
// Generated on 2026-09-25T22:36:55.470Z

export const BUILD_METADATA = {
  commitHash: "a8c3436ef69906b7b9b10d6bb73ce29b72c4ea2c",
  commitHashShort: "a8c3436",
  commitDate: "2026-09-25 22:35:49 +0000",
  commitAuthor: "Mike Richter",
  commitEmail: "michaelsrichter@hotmail.com",
  commitMessage: "Reduce catalog directories for reliable SWA distribution",
  branch: "HEAD",
  buildDate: "2026-09-25T22:36:55.470Z",
  nodeVersion: "v24.18.0",
  repositoryUrl: "https://github.com/michaelsrichter/partnereventfinder",
} as const;

export type BuildMetadata = {
  commitHash: string;
  commitHashShort: string;
  commitDate: string;
  commitAuthor: string;
  commitEmail: string;
  commitMessage: string;
  branch: string;
  buildDate: string;
  nodeVersion: string;
  repositoryUrl: string;
};

/**
 * Get build metadata from build constants or fallback to defaults
 */
export function getBuildMetadata(): BuildMetadata {
  return BUILD_METADATA;
}

/**
 * Get a user-friendly commit link for GitHub
 */
export function getCommitUrl(metadata: BuildMetadata): string {
  if (metadata.repositoryUrl && metadata.commitHash !== 'development') {
    return `${metadata.repositoryUrl}/commit/${metadata.commitHash}`;
  }
  return metadata.repositoryUrl;
}

/**
 * Format commit date for display
 */
export function formatCommitDate(metadata: BuildMetadata): string {
  try {
    const date = new Date(metadata.commitDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    });
  } catch {
    return 'Unknown date';
  }
}

/**
 * Format build date for display
 */
export function formatBuildDate(metadata: BuildMetadata): string {
  try {
    const date = new Date(metadata.buildDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    });
  } catch {
    return 'Unknown date';
  }
}

/**
 * Check if we're running in development mode
 */
export function isDevelopmentBuild(metadata: BuildMetadata): boolean {
  return metadata.commitHash === 'development' || 
         metadata.branch === 'development' ||
         process.env.NODE_ENV === 'development';
}

/**
 * Get a summary of build info for logging
 */
export function getBuildSummary(metadata: BuildMetadata): string {
  return `${metadata.commitHashShort} (${metadata.commitAuthor}) - ${formatCommitDate(metadata)}`;
}
